var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"raw-html-page"},[(_vm.page)?_c('SanitizedHtml',{style:({ 'width': _vm.fullWidth ? '100%' : 'unset' }),attrs:{"content":_vm.page.html,"attributeWhitelist":_vm.attributeWhitelist}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }